/* eslint-disable */
<template>
  <div class="bookings">
    <AdminNavigation ref="navigation" indexProps="5" />
    <div class="top-panel">
      <Header />
      <div class="header-title-section">
        <div class="header-title">
          <h1 v-if="this.$route.query.caseId == undefined || this.$route.query.caseId == '' ">Bookings</h1>
          <h1 v-else>Bookings for Case  {{caseReference}}</h1>
        </div>
        <div class="header-sub-title">{{ title }}</div>
      </div>
    </div>
    <div class="panel">
      <AdminBookingsMenu
        :key="bookingMenuIndex"
        :indexProps="bookingMenuIndex"
      />
      <div class="content">
        <div class="tool-bar row">
          <div class="col">
            <div>
              <el-checkbox v-model="showDefault" size="large" @change="changeFilter">Show appointments created in the past 7days</el-checkbox>
            </div>
            <div class="icon-group right-float-element">
              <el-input style="max-width: 115px" class="mr-1" @input="search()" clearable placeholder="Booking ID" v-model="listParam.BookingID"/>
              <el-input style="max-width: 160px" class="mr-1" @input="search()" clearable placeholder="Examinee Name" v-model="listParam.ClaimantName"/>
              <el-input style="max-width: 160px" class="mr-1" @input="search()" clearable placeholder="Specialist Name" v-model="listParam.SpecialistName"/>
              <el-input style="max-width: 150px" class="mr-1" @input="search()" clearable placeholder="Client Name" v-model="listParam.ClientName"/>
              <el-input style="max-width: 160px" class="mr-1" @input="search()" clearable placeholder="Contact Name" v-model="listParam.ContactName"/>
              <el-select @change="selectPage(1)" style="max-width: 160px" placeholder="Booking Status"  class="mr-1" v-model="listParam.BookingStatus" filterable  clearable>
                <el-option v-for="item in bookingStatuses" :key="item.id" :value="item.id" :label="item.name">{{item.name}}</el-option>
              </el-select>
              <el-date-picker
                  style="width: 260px"
                  v-model="dateValue"
                  type="daterange"
                  start-placeholder="Booking Date Start"
                  popper-class="date-range-picker-popper"
                  value-format="yyyy-MM-dd"
                  format="dd/MM/yyyy"
                  @change="changeDates"
                  end-placeholder="Booking Date End"
                  clearable
              />
            </div>
          </div>
        </div>
        <div class="content-scroll-x">
          <div>
            <div>
              <el-table @row-click="RowClick" ref="bookingTable" :default-sort="{prop: 'BookingID', order: 'descending'}" stripe @sort-change="sortParam" :data="bookings" tooltip-effect="dark" :header-row-style="{background: '#fde9eb', height: '70px'}" :header-cell-style="{fontWeight: 100}">
              <el-table-column
                  width="100"
                  prop="BookingID"
                  label="ID"
                  sortable="custom"
                  show-overflow-tooltip
                  fixed="left"
              >
              </el-table-column>
              <el-table-column
                  width="150"
                  sortable="custom"
                  show-overflow-tooltip
                  label="Examinee"
                  prop="ClaimantFullName"
              >
                <template slot-scope="booking">
                  <span>{{ decodeURIComponent(booking.row.Case.ClaimantFullName)}}</span>
                </template>
              </el-table-column>
              <el-table-column
                  width="150"
                  show-overflow-tooltip
                  prop="DateCreated"
                  sortable="custom"
                  label="Create Date"
              >
                <template slot-scope="scope">
                    <span>{{
                        formatDate(scope.row.DateCreated, "DD/MM/YYYY")
                      }}</span>
                </template>
              </el-table-column>
              <el-table-column
                  width="150"
                  show-overflow-tooltip
                  prop="BookingDateTime"
                  sortable="custom"
                  label="Booking Date"
              >
                <template slot-scope="scope">
                    <span>{{
                        formatDate(scope.row.BookingDateTime, "DD/MM/YYYY")
                      }}</span>
                </template>
              </el-table-column>
                <el-table-column
                    show-overflow-tooltip
                    width="250"
                    prop="BookingType"
                    label="Service Type"
                >
                  <template slot-scope="booking">
                    <span>{{ decodeURIComponent(booking.row.BookingType.BookingTypeName)}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                    width="140"
                    show-overflow-tooltip
                    prop="DeliveryMethod"
                    label="Delivery Method"
                >
                  <template slot-scope="scope">
                    <span v-if="scope.row.BookingType.BookingTypeID !== 19 && scope.row.DeliveryMethodID">{{
                        scope.row.DeliveryMethodID === 1 ? 'In-person' : 'Virtual'
                      }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                    width="120"
                    show-overflow-tooltip
                    prop="BookingDateTime"
                    label="Booking Time"
                >
                  <template slot-scope="scope">
                    <span>{{
                        formatDate(scope.row.BookingDateTime, "HH:mm", "YYYY-MM-DD HH:mm:ss.ssssss")
                      }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                    width="190"
                    show-overflow-tooltip
                    prop="ClaimantBookingDateTime"
                    label="Booking Examinee Time"
                >
                  <template slot-scope="scope">
                    <span>{{
                        formatDate(scope.row.ClaimantBookingDateTime, "HH:mm", "YYYY-MM-DD HH:mm:ss.ssssss")
                      }}</span>
                  </template>
                </el-table-column>
              <el-table-column
                  width="150"
                  show-overflow-tooltip
                  prop="Client"
                  sortable="custom"
                  label="Client"
              >
                <template slot-scope="booking">
                  <span>{{booking.row.Case && booking.row.Case.Client && decodeURIComponent(booking.row.Case.Client.ClientName)}} - {{decodeURIComponent(booking.row.Case.Client.BranchName)}}</span>
                </template>
              </el-table-column>
              <el-table-column
                  width="150"
                  show-overflow-tooltip
                  sortable="custom"
                  prop="ClientContact"
                  label="Contact">
                <template slot-scope="booking">
                  <span>{{ booking.row.ClientContact && decodeURIComponent(booking.row.ClientContact.FirstName + ' ' + booking.row.ClientContact.MiddleName + ' ' + booking.row.ClientContact.Surname)}}</span>
                </template>
              >
              </el-table-column>
              <el-table-column
                  width="150"
                  show-overflow-tooltip
                  prop="Specialist"
                  label="Specialist"
                  sortable="custom"
              >
                <template slot-scope="booking">
                  <span>{{booking.row.Specialist && decodeURIComponent(booking.row.Specialist.Title) + ' ' + decodeURIComponent(booking.row.Specialist.FirstName) + ' ' + decodeURIComponent(booking.row.Specialist.Surname)}}</span>
                </template>
              </el-table-column>
              <el-table-column
                  width="150"
                  show-overflow-tooltip
                  prop="ClaimType"
                  label="Referral Type"
                  sortable="custom"
              >
                <template slot-scope="booking">
                  <span>{{  booking.row.ClaimType && booking.row.ClaimType.ClaimTypeName}}</span>
                </template>
              </el-table-column>
              <el-table-column
                  width="160"
                  sortable="custom"
                  show-overflow-tooltip
                  prop="BookingStatus"
                  label="Booking Status"
              >
                <template slot-scope="booking">
                  <span>{{ booking.row.Status.StatusDescription}}</span>
                </template>
              </el-table-column>
              <el-table-column
                  width="200"
                  prop="custom"
                  label="Paperwork Status"
                  show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <div class="d-flex align-items-center">
                    <el-tooltip  effect="dark" content="Paperwork Processed" placement="bottom">
                      <img
                          class="ml-4 is-icon"
                          src="@/assets/images/paperwork-processed.svg"
                          :class="isDate(scope.row.PaperworkProcessed) ? '' : 'disabled-element'"
                      />
                    </el-tooltip>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            </div>
          </div>
        </div>

        <div v-if="totalCount > listParam.pageSize" class="pagination">
          Page
          <div class="pagination-group">
            <div class="border-icon pagination-current dropdown">
              <div class="pagination-current-text">{{ listParam.pageNum }}</div>
              <div class="pagination-current-icon" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></div>
              <div class="dropdown-menu shadow" aria-labelledby="pagination-current-icon">
                <div class="dropdown-item" v-for="item in (1, Math.ceil(totalCount/listParam.pageSize))" :key="item" :class="listParam.pageNum === item ? 'selected' : ''" :value="item" @click="selectPage(item)">
                  {{ item }}
                </div>
              </div>
            </div>
          </div>
          <div class="pagination-total">of &nbsp; {{ Math.ceil(totalCount/listParam.pageSize) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utilities from "@/assets/js/utilities";
import AdminNavigation from "@/components/AdminNavigation";
import AdminBookingsMenu from "@/components/AdminBookingsMenu";
import Header from "@/components/Header";
import { debounce } from 'lodash';

export default {
  name: "AdminBookings",
  props: ["searchOptionProps"],
  components: {
    AdminNavigation,
    AdminBookingsMenu,
    Header,
  },
  data() {
    return {
      showDefault: true,
      dateValue: '',
      bookings: [],
      allBookings: [],
      limit: 10,
      pagination: utilities.initPagination(),

      filterOption: {
        startDate: "",
        endDate: "",
      },

      caseReference: '',
      totalCount: 0,
      byClient: false,
      byContact: false,
      byClaimant: false,
      byTypeOfClaim: false,
      bySpecialist: false,
      byDate: false,
      byBookingStatus: false,
      byPaperworkStatus: false,

      claimTypes: [],
      bookingStatuses: [],
      paperworkStatuses: [],
      listParam: {
        pageSize: 10,
        pageNum: 1,
        orderBy: 'BookingID',
        BookingDateTimeFrom: '',
        BookingDateTimeTo: '',
        ClientName: '',
        SpecialistName: '',
        ContactName: '',
        ClaimantName: '',
        BookingStatus: null,
        BookingID: null,
        ascOrDesc: 'DESC',
        CreateFromDate: moment().subtract(7, 'd').format('YYYY-MM-DD'),
        CreateToDate: moment().format('YYYY-MM-DD')
      },
      bookingMenuIndex: 0,
      title: "All bookings, listed in booking date order.",
    };
  },
  computed: {
    user() {
      return this.$store.getters['user/getUser'];
    },
  },
  methods: {
    customSort(sort) {
      this.listParam.orderBy = sort.target.id
      this.listParam.ascOrDesc = 'DESC'
      this.selectPage(1)
    },
    RowClick(row) {
      this.openBooking(row?.BookingID)
    },
    search: debounce(function () {
      this.selectPage(1)
    }, 800),
    changeFilter(e) {
      if(e) {
        this.listParam.CreateFromDate = moment().subtract(7, 'd').format('YYYY-MM-DD')
        this.listParam.CreateToDate = moment().format('YYYY-MM-DD')

      } else {
        this.listParam.CreateFromDate = ''
        this.listParam.CreateToDate = ''
      }
      this.selectPage(1)
    },

    isDate(date) {
      return moment(date, "YYYY-MM-DD").isValid()
    },

    sortParam( v ) {
      this.listParam.orderBy = v.prop
      if(v.order === "ascending") {
        this.listParam.ascOrDesc = 'ASC'
      } else if (v.order === "descending") {
        this.listParam.ascOrDesc = 'DESC'
      } else {
        this.listParam.orderBy = null
        this.listParam.ascOrDesc = null
      }

      this.selectPage(1)
    },

    selectPage(index) {
      this.listParam.pageNum = index
      this.loadBookings()
    },

    changeDates(v) {
      if(v) {
        this.listParam.BookingDateTimeFrom = v[0]
        this.listParam.BookingDateTimeTo = v[1]
      } else {
        this.listParam.BookingDateTimeFrom = null
        this.listParam.BookingDateTimeTo = null
      }
      this.selectPage(1)
    },
    filter() {
      if (this.filterOption.startDate == "" && this.filterOption.endDate == "") {
        this.title = "All bookings, listed in due date order."
        return false
      }
      this.title = "Results of a search for bookings between " + moment(this.filterOption.startDate).format("DD/MM/YYYY") + " and " + moment(this.filterOption.endDate).format("DD/MM/YYYY")
      var bookings = this.allBookings.filter((x) => moment(x.bookingDateTime) >= this.filterOption.startDate && moment(x.bookingDateTime) <= this.filterOption.endDate)
      this.paging(bookings)
    },
    formatDate(date, dateToFormat, newFormat)  {
      return utilities.formatDate(date, dateToFormat, newFormat);
    },
    openSearchBooking() {
      this.$refs.navigation.$refs.globalSearch.openSearchBooking();
    },
    openBooking(id) {
      this.$router.push({ name: "admin-manage-booking", query: { id: id } });
    },
    paging(bookings) {
      utilities.disposeTooltip();
      if (bookings.length == 0 || bookings.length <= this.limit) {
        this.bookings = bookings;
        $(".pagination").hide();
      } else {
        this.pagination = utilities.loadPagination(bookings, this.limit);
        this.bookings = this.pagination.list[this.pagination.current];
        $(".pagination").show();
      }
      utilities.initTooltip();
      utilities.hoverTooltip();
    },

    async searchBooking(searchOption) {
      var params = {
        Firstname: searchOption.claimantFirstname,
        Surname: searchOption.claimantSurname,
        UserName: searchOption.userName,
        ClientName: searchOption.clientName,
        CaseRef: searchOption.bookingReference,
        BookingID: searchOption.bookingId,
        BookingDateTimeFrom: searchOption.fromDate ? moment(searchOption.fromDate).format('YYYY-MM-DD') : '',
        BookingDateTimeTo: searchOption.toDate ? moment(searchOption.toDate).format('YYYY-MM-DD'): '',
        BA: searchOption.bodyAreas,
        PC: searchOption.conditions,
        Status: searchOption.status,
        UserID: this.user.id,
        tmp:1,
        SpecialistID: searchOption.specialistId
      };
      this.title =
        "Results of a search for " +
        Object.values(searchOption)
          .filter((x) => x != undefined && x != "")
          .map((x) => "'" + x + "'")
          .join(" and ") +
        ".";

      this.bookings = [];
      var bookings = await utilities.getSearchBookings(params);
      if (bookings) {
        bookings.sort((a, b) => {
          return a.dueDate == ""
            ? 1
            : moment(a.dueDate).isBefore(moment(b.dueDate))
            ? 1
            : -1;
        });
        this.allBookings = _.cloneDeep(bookings);
        this.paging(bookings);
      }

    },
    async loadBookings() {
      await this.$store.dispatch("loading/setLoadComponent", true);
      if (this.$route.query.caseId !== undefined && this.$route.query.caseId !== "") {
        this.listParam.CaseID = this.$route.query.caseId
        let singleCase = await utilities.getCaseByCaseId(this.$route.query.caseId)
        this.caseReference = singleCase.caseReference
      } else if (this.$route.query.clientId !== undefined && this.$route.query.clientId !== "") {
        this.listParam.ClientID = this.$route.query.clientId
      }

      let obj = {...this.listParam}
      for (let key in obj) {
        if (obj[key] === null || obj[key] === '') {
          delete obj[key];
        }
      }
      let {bookings, total} = await utilities.getAllBookingsNew(obj);
      this.bookings = _.cloneDeep(bookings);
      this.totalCount = total
      await this.$store.dispatch("loading/setLoadComponent", false);
    },
    loadData() {
      this.claimTypes =  utilities.getClaimTypes();
      this.bookingStatuses = utilities.getBookingStatuses();
      this.paperworkStatuses = utilities.getPaperworkStatuses();
    },
  },
  async beforeMount() {
    $("body>.tooltip").remove();
    this.$store.dispatch("loading/setLoadComponent", true);
    this.loadData();
    if (this.searchOptionProps != undefined) {
      this.title =
        "Results of a search for " +
        Object.values(this.searchOptionProps)
          .filter((x) => x != undefined && x != "")
          .map((x) => "'" + x + "'")
          .join(" and ") +
        ".";
      await this.searchBooking(this.searchOptionProps);
    } else {
      await this.loadBookings();
    }
    this.$store.dispatch("loading/setLoadComponent", false);
  },
  mounted() {
    $(".pagination").hide();
  },
};
</script>
